export const rowClassPayment = ({archivedPatientData, selectedPaymentID}) => (data) => {


    const filterDataArray = archivedPatientData?.map((patientInfo) => {
        return {
            hospID: patientInfo.hospCases[0].hospID,
            userID: patientInfo.hospCases[0].userID,
            caseNumber: patientInfo.caseNumber,
            paymentID: patientInfo.paymentID
        }
    }) || [];

    const dataType = data?.hospID ? 'Hospital': 'Patient';
    let TableSelectedRowBool = false;
    switch (dataType) {
        case 'Hospital':
            TableSelectedRowBool = filterDataArray.some(item =>{
                const hospUserIDCheck = data?.multipleHospital === 'singlePayment' ? (item.userID === data?.userID) : (item.hospID === data?.hospID && item.userID === data?.userID);
                return (hospUserIDCheck && item.paymentID === selectedPaymentID)

            });

            break;
        case 'Patient':
            // Handle patient case
            TableSelectedRowBool = filterDataArray.some(item => item.caseNumber === data?.caseNumber && item.paymentID === selectedPaymentID);
        default:
            break;
    }

    return {
        'defaultRow': true,
        'Refused': data?.caseType?.includes('Refused'), //data?.caseType?.includes('Refused')
        'TableSelectedRow': TableSelectedRowBool
    }

}